/**
 * CanonicalTag Component
 * Dynamically updates the canonical link tag based on the current route
 * This helps prevent duplicate content issues and ensures proper SEO indexing
 * @component CanonicalTag
 * @file CanonicalTag.tsx
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const CanonicalTag: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Get the base URL (origin)
    const baseUrl = window.location.origin;
    
    // Get the current pathname (without query params or hash)
    const pathname = location.pathname;
    
    // Construct the canonical URL
    const canonicalUrl = `${baseUrl}${pathname}`;
    
    // Find or create the canonical link element
    let canonicalLink = document.getElementById('canonical-link') as HTMLLinkElement;
    
    if (!canonicalLink) {
      // Create the canonical link if it doesn't exist
      canonicalLink = document.createElement('link');
      canonicalLink.id = 'canonical-link';
      canonicalLink.rel = 'canonical';
      document.head.appendChild(canonicalLink);
    }
    
    // Update the href attribute
    canonicalLink.href = canonicalUrl;
  }, [location.pathname]);

  // This component doesn't render anything
  return null;
};

export default CanonicalTag;

